/**
 * The client half of the password policy from `auth/users.py`.
 *
 * Duplicated from the server for immediate feedback as the user types — the
 * server is still the authority and re-checks on every write. If the two ever
 * disagree the server wins, so keep this in step with `password_problem()`.
 *
 * It lives here rather than beside one screen because three places now need
 * it: first-admin setup, self-service change, and admin reset. Three copies
 * would drift, and the copy that drifted would be the one that let a password
 * through the form only for the server to refuse it.
 */
export const MIN_PASSWORD_LENGTH = 8

export function passwordProblem(password: string): string | null {
  if (!password) return 'נא למלא סיסמה.'
  if (password.length < MIN_PASSWORD_LENGTH)
    return `הסיסמה חייבת להכיל לפחות ${MIN_PASSWORD_LENGTH} תווים.`
  if (![...password].some((ch) => !/\p{L}/u.test(ch)))
    return 'הסיסמה חייבת לכלול לפחות תו אחד שאינו אות (ספרה או סימן).'
  return null
}
